/** White-label helpers — vendor names never reach the UI. */
export const BRAND_ENGINE = "ELPM";

/** "Suno V6 · cover" → "ELPM V6 · cover" for model strings persisted before white-labelling. */
export function displayModel(model) {
  return (model || "").replace(/\bSuno\b/g, BRAND_ENGINE);
}
